import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationDto } from '../../../../api/gen';
import { SignalingService } from '../signaling.service';

@Injectable({ providedIn: 'root' })
export class NotificationCenterMessagingService {
  private readonly messageStream = new Subject<NotificationDto>();
  readonly notificationCreated = this.messageStream.asObservable();

  constructor(private readonly signalingService: SignalingService) {}

  public addNotificationCenterListener(): void {
    this.signalingService
      .getHubConnection()
      .on(
        'notificationCenter_notificationCreatedV2',
        (data: NotificationDto) => {
          this.messageStream.next(data);
        },
      );
  }
}
